import firebase from 'firebase'

// export const config = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
// };

// Initialize Firebase
var prodConfig = {
    apiKey: "AIzaSyAqOVaoe7nyU0HS3GPekzCSGUAc_Tdras8",
    authDomain: "tool.pre.do",
    databaseURL: "https://idea2inc-46ccd.firebaseio.com",
    projectId: "idea2inc-46ccd",
    storageBucket: "idea2inc-46ccd.appspot.com",
    messagingSenderId: "625038621477",
}
var devConfig = {
    apiKey: "AIzaSyCmjeFuDoMeOkeG5J-TCXzDJ1vtaDqUXjE",
    authDomain: "dev.pre.do",
    databaseURL: "https://dev-pre-do.firebaseio.com",
    projectId: "dev-pre-do",
    storageBucket: "dev-pre-do.appspot.com",
    messagingSenderId: "943752089124",
}

var dev2Config = {
    apiKey: "AIzaSyAbnzFNP9xlfg3cC14PpU1z5t3P8zVIxBY",
    authDomain: "dev2-pre-do.firebaseapp.com",
    databaseURL: "https://dev2-pre-do.firebaseio.com",
    projectId: "dev2-pre-do",
    storageBucket: "dev2-pre-do.appspot.com",
    messagingSenderId: "388866929047",
}
var full = window.location.host
// var parts = full.split('.')
// var subdomain = parts[0]
var defApp
if(full==='tool.pre.do'){
    defApp = firebase.initializeApp(prodConfig)
    console.log('PROD config')
}else if(full==='dev-pre-do2.firebaseapp.com'){
    defApp = firebase.initializeApp(dev2Config)
    console.log('DEV2 config')
}else{
    defApp = firebase.initializeApp(devConfig)
    console.log('DEV config')
}

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a sevice worker
//   `messaging.setBackgroundMessageHandler` handler.
firebase.messaging().onMessage(function (payload) {
    console.log("Message received. ", payload)
    //TODO: implement highlighting of notification icon
})


export const defaultApp = defApp
export default firebase



// WEBPACK FOOTER //
// ./src/firebase.js